import React from "react"

import { Typography, makeStyles, Box } from "@material-ui/core"
import { Portlet } from "."

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(4),
  },
  primaryText: {
    fontSize: 40,
    fontWeight: theme.typography.fontWeightMedium,
    fontFamily: theme.typography.h1.fontFamily,
    lineHeight: 48 + "px",
    marginBottom: theme.spacing(1),
  },
  secondaryText: {},
  price: {
    fontSize: 48,
    lineHeight: 56 + "px",
    "& .dollar-sign": {
      verticalAlign: "super",
      fontSize: 16,
    },
    "& .period": {
      verticalAlign: "baseline",
      fontSize: 16,
      color: theme.palette.text.secondary,
    },
  },
  inclusion: {
      marginBottom: theme.spacing(1),
    "& p": {
      fontWeight: theme.typography.fontWeightBold,
    },
  },
  feature: {

  },
}))

const Pricing = ({
  price,
  features,
  inclusions,
  primaryText
}) => {
  const classes = useStyles()

  return (
    <Portlet className={classes.root}>
      <Typography className={classes.primaryText}>{primaryText}</Typography>
      <Typography className={classes.price}>
        <span className="dollar-sign">AU$</span>
        {price}
        <span className="period">/mo</span>
      </Typography>
      <Box textAlign="left" width="100%">
        <Typography variant="caption">Inclusions</Typography>
        <ul style={{ listStyle: "none", paddingLeft: 0 }}>
          {inclusions.map(inclusion => (
            <li key={inclusion} className={classes.inclusion}>
              <Typography>{inclusion}</Typography>
            </li>
          ))}
        </ul>
      </Box>
      <Box textAlign="left" width="100%">
        <Typography variant="caption">Features</Typography>
        <ul style={{ listStyle: "none", paddingLeft: 0 }}>
          {features.map(feature => (
            <li key={feature} className={classes.feature}>
              <Typography>{feature}</Typography>
            </li>
          ))}
        </ul>
      </Box>
    </Portlet>
  )
}

export default Pricing
